import { NgModule } from '@angular/core';
import { Routes, RouterModule} from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ViewScheduleComponent } from './view-schedule.component';
import { PendingChangesGuard } from '../../pending-changes.guard';

const ViewScheduleRoutes: Routes = [
    { path: '', component: ViewScheduleComponent, canDeactivate: [PendingChangesGuard]  },
    { path: ':id', component: ViewScheduleComponent, canDeactivate: [PendingChangesGuard]  },
];

@NgModule({
    imports: [
        RouterModule.forChild(ViewScheduleRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class ViewScheduleRoutingModule {}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/view-schedule.routing.ts